/*
 * @Author: 张天昊
 * @Date: 2024-05-29 15:42:51
 * @LastEditTime: 2024-09-03 17:06:55
 * @LastEditors: Please set LastEditors
 * @Description: 集成按钮操作
 * @FilePath: /Mobile/src/pages/itineraryUniversal/composables/useAuth.js
 */
import { computed, ref } from 'vue';
import store from '@/store';
import moment from 'moment';
import { SCENE_TYPE, dateStrFormat1 } from '../constants';
import router from '@/router/routers';

export function useAuth() {
  const detailInfo = computed(
    () => store.state.itineraryUniversal.detailInfo.value
  );

  function getTeamDiffTime(field, reference) {
    if (!detailInfo.value) {
      return null;
    }
    const infoMessage = detailInfo.value.itineraryInfoMessage;
    if (!infoMessage[field]) {
      return null;
    }
    if (!reference) {
      reference = moment();
    }
    return reference.diff(moment(infoMessage[field], dateStrFormat1));
  }
  // 根据后端返回的数据定义权限
  const showAgencyAuditBtn = computed(() =>
    getOperationAuth('audit')
  );
  const travelAgencyDetailAuth = computed(() =>
    getOperationAuth('travelDetail')
  );
  const guideDetailAuth = computed(() => getOperationAuth('guideDetail'));
  const privacyApplyButtonAuth = computed(() =>
    getOperationAuth('touristApply')
  );
  // 行程是否开始
  const isStart = computed(() => {
    const difftime = getTeamDiffTime('teamStartDate');
    if (difftime === null) {
      return false;
    }
    return difftime >= 0;
  });
  const isEnd = computed(() => {
    const difftime = getTeamDiffTime('teamEndDate');
    if (difftime === null) {
      return false;
    }
    return difftime >= 0;
  });

  // 变更导游时间
  const isSendTime = computed(() => {
    if (!detailInfo.value) {
      return false;
    }
    const infoMessage = detailInfo.value.itineraryInfoMessage;
    const guideConfirm = detailInfo.value.guideConfirm;

    if (!guideConfirm || !infoMessage.teamStartDate || !guideConfirm.sendTime) {
      return false;
    }
    const difftime = moment(guideConfirm.sendTime, dateStrFormat1).diff(
      moment(infoMessage.teamStartDate, dateStrFormat1)
    );
    if (difftime > 0) {
      return true; // 开团后变更导游的
    } else {
      return false; // 开团前变更导游的
    }
  });

  /**
   * 是否展示导游带团操作
   * 复用逻辑
   * https://git.ybsjyyn.com/guide_travel/team-supervision-itinerary-app/blob/master/src/pages/Home/Message/index.vue#L246
   */
  const showGuideToggleTourGroupBtn = computed(() => {
    if (!detailInfo.value) {
      return false;
    }
    const guideConfirm = detailInfo.value.guideConfirm;
    if (!guideConfirm) {
      return false;
    }
    const infoMessage = detailInfo.value.itineraryInfoMessage;
    const preCheck =
      infoMessage.checkState !== -1 && guideConfirm.confirm === 3;
    if (!preCheck) {
      return false;
    }

    // 团队游 teamType = 9 基准时间向前调1小时
    const difftime = getTeamDiffTime(
      'teamStartDate',
      infoMessage.teamType === '9' ? moment().subtract(1, 'hours') : moment()
    );
    const isStart = difftime === null ? false : difftime >= 0;

    return !isStart || (isSendTime.value && guideConfirm.isChange >= 1);
  });

  /**
   * 是否展示导游变更景区操作
   * 复用逻辑
   * https://git.ybsjyyn.com/guide_travel/team-supervision-itinerary-app/blob/master/src/pages/Home/Message/index.vue#L254
   */
  const showScenicModifyBtn = computed(() => {
    if (!detailInfo.value) {
      return false;
    }
    const guideConfirm = detailInfo.value.guideConfirm;
    if (!guideConfirm) {
      return false;
    }
    const infoMessage = detailInfo.value.itineraryInfoMessage;
    return (
      infoMessage.checkState === 2 &&
      isStart.value &&
      guideConfirm.confirm === 1
    );
  });

  /**
   * 是否展示旅行社变更行程操作
   * 复用逻辑
   * https://git.ybsjyyn.com/guide_travel/team-supervision-itinerary-app/blob/master/src/pages/Home/Message/index.vue#L226
   */
  const showItineraryModifyBtn = computed(() => {
    if (!detailInfo.value) {
      return false;
    }
    const { scene } = router.currentRoute.query;
    if (scene !== SCENE_TYPE.旅行社) {
      return false;
    }
    const guideConfirm = detailInfo.value.guideConfirm;
    const infoMessage = detailInfo.value.itineraryInfoMessage;
    return !guideConfirm && infoMessage.checkState === 2 && isStart.value;
  });

  function getOperationAuth(field) {
    return detailInfo.value
      ? detailInfo.value.operationAuth
        ? !!detailInfo.value.operationAuth[field]
        : false
      : false;
  }

  return {
    showAgencyAuditBtn,
    travelAgencyDetailAuth,
    guideDetailAuth,
    privacyApplyButtonAuth,
    showGuideToggleTourGroupBtn,
    showScenicModifyBtn,
    showItineraryModifyBtn
  };
}
